module.exports = __webpack_public_path__ + "r-v3/img/coachmark_arrow_blue_04.743fc558.svg";